import React from 'react'
import { Col } from 'reactstrap'
import styled from 'styled-components'
import SearchForm from './index'

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  padding-bottom: 16px;

  @media (min-width: 768px) {
    padding-bottom: 32px;
  }
`

export const Hero = styled.div`
  background-color: ${props => props.theme.colors.secondary};
  margin: 0;
`

export const HeroBody = styled.div`
  z-index: 2;
`

export const Content = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (min-width: 992px) {
    padding-bottom: 32px;
  }
  @media (max-width: 991.98px) {
    padding: 32px 0;
  }
`

const FullSearch = ({ searchState, onSearchStateChange }) => (
  <SearchForm searchState={searchState} onSearchStateChange={onSearchStateChange} />
)

export default FullSearch
